"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateYouTubeChannelDto = instanceOfCreateYouTubeChannelDto;
exports.CreateYouTubeChannelDtoFromJSON = CreateYouTubeChannelDtoFromJSON;
exports.CreateYouTubeChannelDtoFromJSONTyped = CreateYouTubeChannelDtoFromJSONTyped;
exports.CreateYouTubeChannelDtoToJSON = CreateYouTubeChannelDtoToJSON;
exports.CreateYouTubeChannelDtoToJSONTyped = CreateYouTubeChannelDtoToJSONTyped;
/**
 * Check if a given object implements the CreateYouTubeChannelDto interface.
 */
function instanceOfCreateYouTubeChannelDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('channel_id' in value) || value['channel_id'] === undefined)
        return false;
    if (!('channel_url' in value) || value['channel_url'] === undefined)
        return false;
    return true;
}
function CreateYouTubeChannelDtoFromJSON(json) {
    return CreateYouTubeChannelDtoFromJSONTyped(json, false);
}
function CreateYouTubeChannelDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'channel_id': json['channel_id'],
        'channel_url': json['channel_url'],
    };
}
function CreateYouTubeChannelDtoToJSON(json) {
    return CreateYouTubeChannelDtoToJSONTyped(json, false);
}
function CreateYouTubeChannelDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'channel_id': value['channel_id'],
        'channel_url': value['channel_url'],
    };
}
